/**
 * Custom image loader used to serve original images from CDN,
 * which prevent extra image optimizations on NextJS server.
 *
 * @see documentation {@link https://nextjs.org/docs/pages/building-your-application/optimizing/images#loaders}
 */
"use client"

export default function imageLoader({ src }) {
  return src
}
